import script from "./PageProfile.vue?vue&type=script&setup=true&lang=js"
export * from "./PageProfile.vue?vue&type=script&setup=true&lang=js"

import "./PageProfile.vue?vue&type=style&index=0&id=d3371160&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d3371160"]])

export default __exports__